import { render, staticRenderFns } from "./CardSmallLight.vue?vue&type=template&id=309f4fe1&"
import script from "./CardSmallLight.vue?vue&type=script&lang=js&"
export * from "./CardSmallLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports